export default __webpack_public_path__ + "static/media/notas-del-cirujano-clean.8fdb017f.png";